import { REVIEW_RATING_DEFAULT_MAX, REVIEW_RATING_DEFAULT_MIN } from 'types/review';

type StarType = 'full' | 'half' | 'empty';

type ReviewTransformReturnType = {
    ratingToStars: (rating: number, max?: number, min?: number, fullOnly?: boolean) => StarType[];
};

export const useReviewTransform = (): ReviewTransformReturnType => {
    const ratingToStars = (
        rating: number,
        max: number = REVIEW_RATING_DEFAULT_MAX,
        min: number = REVIEW_RATING_DEFAULT_MIN,
        fullOnly: boolean = false,
    ) => {
        return Array.from({ length: max - min }, (_, index): StarType => {
            const value = min + index;
            const calculatedAvg = ratingToPercent(rating, max, min);
            const step = 100 / (max - min);
            const isMoreThanCurrentStep = calculatedAvg > (value + 0.5) * step;
            const isCurrentStepAndHalfAllowed = calculatedAvg > value * step && !fullOnly;

            if (isMoreThanCurrentStep) {
                return 'full';
            } else if (isCurrentStepAndHalfAllowed) {
                return 'half';
            }

            return 'empty';
        });
    };

    return {
        ratingToStars,
    };
};

export const ratingToPercent = (rating: number, max: number = 5, min: number = 0) => {
    return (rating / (max - min)) * 100;
};
